import React from 'react'
import { isEqual } from 'lodash'
import 'rc-steps/assets/index.css'

import AddCompetitorComponent from '../../../components/competitorTracking/AddCompetitorComponent'
import {
  kissmetricsRecordingEvent,
  KISSMETRICS_TRACK_EVENTS,
} from '../../../utils/kissmetrics'
import { translate } from '../../../utils/translation'
import { VALID_STATUS } from '../../../components/input/TagInput/CompetitorTagInput'

import { StepWrapper, NavButtons, NavButton, StepContent } from './styled'

export default class Step4 extends React.Component {
  constructor(props) {
    super(props)

    const { locations, competitors, MAX_COMPETITORS_PER_PROJECT } = this.props

    this.state = {
      locations,
      selectedLocations: locations,
      invalidCompetitors:
        competitors.length * locations.length > MAX_COMPETITORS_PER_PROJECT,
      invalidLocations: false,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!isEqual(prevState.locations, nextProps.locations)) {
      return {
        locations: nextProps.locations,
        selectedLocations: nextProps.locations,
        invalidCompetitors:
          nextProps.competitors.length * nextProps.locations.length >
          nextProps.MAX_COMPETITORS_PER_PROJECT,
        invalidLocations:
          nextProps.locations.length === 0 ||
          nextProps.locations.length >
            nextProps.MAX_COMPETITORS_LOCATIONS_PER_PROJECT,
      }
    }
    return null
  }

  setNewCompetitors = (newCompetitors) => {
    const { selectedLocations } = this.state
    const {
      competitors,
      showUpgradeModal,
      setCompetitors,
      MAX_COMPETITORS_PER_PROJECT,
    } = this.props
    const totalCount = newCompetitors.length * selectedLocations.length

    if (totalCount > MAX_COMPETITORS_PER_PROJECT) {
      if (newCompetitors.length > competitors.length)
        showUpgradeModal('step4_reached_maximum_competitors')
    }
    setCompetitors(newCompetitors)
    this.setState({
      invalidCompetitors: totalCount > MAX_COMPETITORS_PER_PROJECT,
    })
  }

  setLocations = (locations) => {
    const { competitors, showUpgradeModal } = this.props

    const totalCount = competitors.length * locations.length
    const {
      MAX_COMPETITORS_PER_PROJECT,
      MAX_COMPETITORS_LOCATIONS_PER_PROJECT,
    } = this.props
    this.setState({
      invalidCompetitors: totalCount > MAX_COMPETITORS_PER_PROJECT,
      invalidLocations:
        locations.length === 0 ||
        locations.length > MAX_COMPETITORS_LOCATIONS_PER_PROJECT,
      selectedLocations: locations,
    })
    if (
      totalCount > MAX_COMPETITORS_PER_PROJECT ||
      locations.length > MAX_COMPETITORS_LOCATIONS_PER_PROJECT
    ) {
      showUpgradeModal('step4_reached_maximum_competitors')
    }
  }

  render() {
    const {
      pendingData,
      suggestedCompetitors,
      nextStep,
      onSubmit,
      previousStep,
      competitors,
      newAddonProject,
      domain,
      locations,
      openEditLocationsModal,
      showUpgradeModal,
    } = this.props
    const { invalidCompetitors, selectedLocations, invalidLocations } =
      this.state

    const hasInvalidOrValidating = competitors.some(
      (c) =>
        c.status === VALID_STATUS.invalid ||
        c.status === VALID_STATUS.validating,
    )

    return (
      <StepWrapper width="100%">
        <StepContent>
          <AddCompetitorComponent
            domain={domain}
            competitorsInProject={[]}
            locations={locations}
            pendingData={pendingData}
            suggestedCompetitors={suggestedCompetitors}
            competitorsToAdd={competitors}
            setCompetitorsToAdd={this.setNewCompetitors}
            selectedLocations={selectedLocations}
            setSelectedLocations={this.setLocations}
            areLocationsInvalid={invalidLocations}
            areCompetitorsInvalid={invalidCompetitors}
            newAddonProject={newAddonProject}
            openEditLocationsModal={openEditLocationsModal}
          />
        </StepContent>
        <NavButtons>
          <NavButton
            testId="add-project-step4-back"
            color="grey"
            onClick={previousStep}
            tag={translate('back')}
          />
          <NavButton
            testId="add-project-step4-skip"
            color="grey"
            onClick={(event) => {
              kissmetricsRecordingEvent(
                KISSMETRICS_TRACK_EVENTS.project_creation_actions,
                {
                  'project flow action': 'competitor add skip',
                },
              )

              nextStep(event)
              onSubmit([], true)
            }}
            tag={translate('skip')}
          />
          <NavButton
            testId="add-project-step4-next"
            color="orange"
            onClick={(event) => {
              if (competitors.length === 0) {
                return
              }
              if (!invalidCompetitors && !invalidLocations) {
                kissmetricsRecordingEvent(
                  KISSMETRICS_TRACK_EVENTS.project_creation_actions,
                  {
                    'project flow action': 'competitor add next',
                  },
                )

                nextStep(event)
                onSubmit(selectedLocations)
                return
              }

              if (invalidCompetitors) {
                showUpgradeModal()
              }
            }}
            tag={translate('next')}
            disabled={
              invalidCompetitors ||
              invalidLocations ||
              competitors.length === 0 ||
              hasInvalidOrValidating
            }
          />
        </NavButtons>
      </StepWrapper>
    )
  }
}
